import React from "react";
import { Container, FormContainer, OuterContainer } from "./styles";
import { Formik } from "formik";
import {
  Paper,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import styled from "styled-components";
import theme from "../../../../assets/theme";
import { PrimaryCTAButton } from "../../../common/Buttons";
import FormField from "../../../schedules/FormInputs";
import useLoader from "../../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import EventService from "../../../../services/EventService";

const PushPollResults = ({
  IndividualPollResponses,
  eventId,
  setTriggerPoll,
  poll,
}) => {
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();

  const inputs = [
    {
      name: "pushQuestionNumber",
      label: "Push Question Number",
      type: "select",
    },
  ];

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "push poll question..." });
      const payload = {
        pollQuestions: values?.pollQuestions?.map((item) => ({
          ...item,
          disabled:
            values?.livePolls?.acceptingResponse === "notAccept"
              ? true
              : item?.disabled,
          latest:
            values?.livePolls?.pushQuestionNumber === item?.question
              ? true
              : item?.latest,
          accept:
            values?.livePolls?.pushQuestionNumber === item?.question
              ? values?.livePolls?.acceptingResponse
              : item?.accept,
        })),
        livePolls: {
          pushQuestionNumber: "",
          pushRollResults: "",
          acceptingResponse: "",
        },
      };
      const response = await EventService.updateEvent(eventId, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      setTriggerPoll(true);
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  return (
    <OuterContainer>
      <Container>
        <Formik
          initialValues={{
            pollQuestions: IndividualPollResponses?.length
              ? IndividualPollResponses?.map((item) => ({
                  question: item?.question,
                  options: item?.options,
                  disabled: item?.disabled,
                  accept: item?.accept,
                }))
              : [
                  {
                    question: "None",
                    options: ["none"],
                    disabled: false,
                    accept: "",
                  },
                ],
            livePolls: {
              pushQuestionNumber: "",
              pushRollResults: "",
              acceptingResponse: "",
            },
          }}
          enableReinitialize
          onSubmit={onFormSubmit}
          validateOnBlur
          validateOnChange
          validationSchema={""}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            setFieldValue,
            handleSubmit,
            resetForm,
          }) => (
            <FormContainer>
              <Paper
                elevation={3}
                style={{
                  width: "77%",
                  padding: 16,
                  border: "1px solid #e1e3ee",
                  marginTop: "15px",
                  marginBottom: "15px",
                  borderRadius: "8px",
                }}
              >
                <GridLabel>Push Poll Results</GridLabel>
                <Grid
                  container
                  item
                  xs={12}
                  spacing={3}
                  style={{ padding: 16 }}
                >
                  {inputs.map((item, idx) => (
                    <Grid
                      item
                      xs={isBigScreen ? 6 : 12}
                      key={item.name}
                      style={styles.gridItem}
                    >
                      <FormField
                        {...{ item, values, handleChange, errors, touched }}
                        name={`livePolls.${item.name}`}
                        menuItems={
                          item.name === "pushQuestionNumber"
                            ? values?.pollQuestions.map((item) => ({
                                label: item.question,
                                value: item.question,
                                disabled: item.disabled,
                                accept: item.accept,
                              }))
                            : item.menuItems
                        }
                        value={values.livePolls[item.name]}
                        direction={"row"}
                      />
                    </Grid>
                  ))}
                </Grid>
                <PrimaryCTAButton
                  style={{ width: "auto", marginLeft: "24px" }}
                  onClick={handleSubmit}
                >
                  Push Live
                </PrimaryCTAButton>
              </Paper>
            </FormContainer>
          )}
        </Formik>
      </Container>
    </OuterContainer>
  );
};

const styles = {
  container: {
    backgroundColor: "#A9A9A9", // gray background
    padding: "20px",
    borderRadius: "8px",
  },
  gridItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    fontWeight: "bold",
  },
};

export default PushPollResults;

const GridLabel = styled(Typography)(() => ({
  width: "250px",
  color: " #00838c",
  fontSize: "15px",
  marginTop: "10px",
  marginBottom: "10px",
  marginLeft: "15px",
  fontFamily: theme.fonts.primaryFontSemiBold,
}));
